export default class Documentation {

  id = null;
  documentType = null;
  fileType = null;

  size = 0;
  filename = "";
  md5 = "";
  deleted = false;

  startDate = "";
  endDate = "";

  savedOn = "";
  signed = false;
  toBeSigned = false;
  generated = false;

  constructor() {
  }
}
